(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/helpers/handlebarshelpers.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/helpers/handlebarshelpers.js'); (function() {
  'use strict';

  var trinidad;

  if (typeof exports === 'object') {
    trinidad = require('trinidad-core').core;
    registerHelpers(require('hbs'), trinidad.components.require('libs', 'moment').moment, require('underscore'));
  } else {
    registerHelpers(Handlebars, moment, _);
  }

  function registerHelpers(hbs, moment, _) {
    hbs.registerHelper('getSuspensionPeriodOptions', function(suspensionType, activeSuspensions) {
      var activeSuspension,
        options = [
          {
            value: 3,
            disabled: false,
            selected: false,
            text: '3 månader'
          },
          {
            value: 6,
            disabled: false,
            selected: false,
            text: '6 månader'
          },
          {
            value: 12,
            disabled: false,
            selected: false,
            text: '1 år'
          },
          {
            value: 36,
            disabled: false,
            selected: false,
            text: '3 år'
          }
        ];
      if (activeSuspensions) {
        activeSuspension = _.filter((typeof activeSuspensions.toJSON === 'function' && activeSuspensions.toJSON()) || activeSuspensions, function(b) {
          return b.product === suspensionType;
        })[0];
        if (activeSuspension) {
          _.each(options, function(option) {
            if (option.value < activeSuspension.period || (option.value === activeSuspension.period && moment(activeSuspension.validFrom).format('YYYYMMDD') === new moment().format('YYYYMMDD'))) {
              option.disabled = true;
            }
          });
        }
      }

      return options;
    });

    hbs.registerHelper('isEmpty', function() {
      var params = Array.prototype.slice.call(arguments, 0, arguments.length - 1),
        i = params.length,
        options = arguments[arguments.length - 1];

      while (i--) {
        if (params[i] && typeof params[i].size === 'function' ? params[i].size() : !_.isEmpty(params[i])) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }

      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });

    hbs.registerHelper('isListDefaultProducts', function(activeSuspensions) {
      if (activeSuspensions && !activeSuspensions.dataError) {
        activeSuspensions.forEach(function(a) {
          let prodName = a.product;
          if (prodName !== 'all' && prodName !== 'vegas' && prodName !== 'quickGames') {
            return false;
          }
        });
        return true;
      }
      return false;

    });

    hbs.registerHelper('productNotVegas', function(product) {
      if (product === 'vegas') {
        return false;
      }
      return true;

    });

    hbs.registerHelper('periodIsTerminable', function(period) {
      if (period >= 12) {
        return true;
      }
      return false;

    });
  }
})();

 })(window);